import * as React from "react";
const SvgFilter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M33.293 33.293A1 1 0 0 0 33 34v2.586a1 1 0 0 0 .293.707l6.414 6.414a1 1 0 0 1 .293.707V51l4-4v-2.586a1 1 0 0 1 .293-.707l6.414-6.414a1 1 0 0 0 .293-.707V34a1 1 0 0 0-1-1H34a1 1 0 0 0-.707.293"
    />
  </svg>
);
export default SvgFilter;
